__turbopack_context__.v({
  "accessibilityStatement": "Footer-module__Lt_XHG__accessibilityStatement",
  "accordionContent": "Footer-module__Lt_XHG__accordionContent",
  "accordionLabel": "Footer-module__Lt_XHG__accordionLabel",
  "cookieSettingsLink": "Footer-module__Lt_XHG__cookieSettingsLink",
  "footer": "Footer-module__Lt_XHG__footer",
  "footerContent": "Footer-module__Lt_XHG__footerContent",
  "footerLink": "Footer-module__Lt_XHG__footerLink",
  "grid": "Footer-module__Lt_XHG__grid",
  "item": "Footer-module__Lt_XHG__item",
  "localeSwitchLink": "Footer-module__Lt_XHG__localeSwitchLink",
  "logo": "Footer-module__Lt_XHG__logo",
  "mobileOnly": "Footer-module__Lt_XHG__mobileOnly",
  "organizationInfo": "Footer-module__Lt_XHG__organizationInfo",
  "organizationInfoDetails": "Footer-module__Lt_XHG__organizationInfoDetails",
  "socialLink": "Footer-module__Lt_XHG__socialLink",
  "socialLinks": "Footer-module__Lt_XHG__socialLinks",
  "textContent": "Footer-module__Lt_XHG__textContent",
  "transparentCivilSocietyLink": "Footer-module__Lt_XHG__transparentCivilSocietyLink",
  "wideOnly": "Footer-module__Lt_XHG__wideOnly",
});
